import React, { useState, useEffect, useRef } from "react";
import { Modal, Button } from "react-bootstrap";
import { slugify } from "../../utils/stringTools";
import { BiPencil } from "react-icons/bi";

export function EditCommonField({ field, onChange }) {
  /* -----------------------------
     States locaux
  ----------------------------- */

  const [localName, setLocalName] = useState(field.name || "");
  const [localClass, setLocalClass] = useState(field["x-class"] || "");
  const [localTitle, setLocalTitle] = useState(field.title || "");
  const [showTitleModal, setShowTitleModal] = useState(false);

  const inputNameRef = useRef(null);

  /* -----------------------------
     Sync changement de champ
  ----------------------------- */

  useEffect(() => {
    setLocalName(field.name || "");
    setLocalClass(field["x-class"] || "");
    setLocalTitle(field.title || "");
  }, [field.id]);

  useEffect(() => {
    if (field.error?.name) {
      inputNameRef.current?.focus();
    }
  }, [field.error]);

  /* -----------------------------
     Slug logic
  ----------------------------- */

  const handleBlurTitle = (value) => {
    const clean = value.trim();
    if (clean && !field.name) {
      const slug = slugify(clean);
      setLocalName(slug);
      onChange("name", slug);
    }
  };

  const handleBlurName = () => {
    const value = localName.trim();
    if (!value) return;

    const slug = slugify(value);
    setLocalName(slug);

    if (slug !== field.name) {
      onChange("name", slug);
    }
  };

  const handleTitleChange = (value) => {
    const sanitized = value.replace(/[\r\n]+/g, " "); // interdit les retours ligne
    setLocalTitle(sanitized);
    onChange("title", sanitized);
  };

  /* -----------------------------
     Render
  ----------------------------- */

  return (
    <div className="mb-4">
      {/* === Étiquette (inline editable) === */}
      <div className="mb-3">
        <label className="form-label">Étiquette</label>

        <div className="d-flex gap-2 align-items-center">
          <input
            type="text"
            className="form-control form-control-sm"
            value={localTitle}
            onChange={(e) => handleTitleChange(e.target.value)}
            onBlur={(e) => handleBlurTitle(e.target.value)}
          />

          <button
            type="button"
            className="btn btn-sm btn-outline-primary"
            onClick={() => setShowTitleModal(true)}
          >
            <BiPencil size={16} />
          </button>
        </div>
      </div>

      {/* === Nom interne === */}
      <div className="mb-3">
        <label className="form-label">Nom (attribute name)</label>

        <input
          ref={inputNameRef}
          type="text"
          className={`form-control form-control-sm ${field.error?.name ? "is-invalid border-danger" : ""
            }`}
          placeholder="nom_interne_du_champ"
          value={localName}
          onChange={(e) => setLocalName(e.target.value)}
          onBlur={handleBlurName}
          onKeyDown={(e) => e.key === "Enter" && handleBlurName()}
        />

        {field.error?.name && (
          <div className="invalid-feedback">
            {field.error.name.message}
          </div>
        )}
      </div>

      {/* === Classe CSS === */}
      <div className="mb-3">
        <label className="form-label">Classe CSS</label>

        <input
          type="text"
          className="form-control form-control-sm"
          placeholder="ex: mt-3 mb-2 text-primary"
          value={localClass}
          onChange={(e) => setLocalClass(e.target.value)}
          onBlur={() => onChange("x-class", localClass.trim())}
        />
      </div>

      {/* === Options === */}
      <div className="form-check mb-2">
        <div className="d-flex gap-3">
          <div className="flex-grow-1">
            <input
              className="form-check-input"
              type="checkbox"
              checked={field["x-required"] || false}
              onChange={(e) =>
                onChange("x-required", e.target.checked)
              }
              id={`required_${field.id}`}
            />
            <label
              className="form-check-label"
              htmlFor={`required_${field.id}`}
            >
              Champ requis
            </label>
          </div>

          <div className="flex-grow-1">
            <input
              className="form-check-input"
              type="checkbox"
              checked={field.readonly || false}
              onChange={(e) =>
                onChange("x-readonly", e.target.checked)
              }
              id={`readonly_${field.id}`}
            />
            <label
              className="form-check-label"
              htmlFor={`readonly_${field.id}`}
            >
              Lecture seule
            </label>
          </div>
        </div>
      </div>

      {/* =========================
           MODALE ÉDITION ÉTIQUETTE
         ========================= */}
      <Modal
        show={showTitleModal}
        onHide={() => setShowTitleModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Modifier l’étiquette</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <textarea
            className="form-control"
            rows={4}
            value={localTitle}
            onChange={(e) =>
              handleTitleChange(e.target.value)
            }
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault(); // interdit retour ligne
              }
            }}
            autoFocus
          />
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowTitleModal(false)}
          >
            Annuler
          </Button>

          <Button
            variant="primary"
            onClick={() => {
              handleBlurTitle(localTitle);
              setShowTitleModal(false);
            }}
          >
            Enregistrer
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default EditCommonField;